module.exports = __webpack_public_path__ + "static/media/unionpay.aace3bd4.png";